<template>
  <icon-rect :stroke-width="0" fill="#606266"></icon-rect>
</template>
<script>
export default {
  name: 'icon-rect-solid',
}
</script>